import styles from './webinars.module.scss'
import cn from 'classnames'
import BecomeMember from '@/components/BecomeMember/BecomeMember'
import Button from '@/components/Button'
import DynamicContent from '@/components/DynamicContent/DynamicContent'
import PageHeader from '@/components/PageHeader'
import AppLayout from '@/layouts/AppLayout'
import ContentLayout from '@/layouts/ContentLayout'
import LayoutService from '@/services/LayoutService'
import WebinarService from '@/services/WebinarService'
import getSectionData from '@/utils/getSectionData'
import resolveSidebarBlocks from '@/utils/resolveSidebarBlocks'

function Page({ page, layoutData }) {
  const showSidebar = page.sidebarAcf.showSidebar
  const acfMain = page.dynamicAcf.dynamicContent
  const acfAside = [...resolveSidebarBlocks(page), { contentType: 'socials', socials: page.socials }]

  return (
    <AppLayout data={layoutData}>
      <PageHeader data={page.sections} />

      <ContentLayout className={cn(styles['root'])}>
        <ContentLayout.Main>
          <ContentLayout.Main.IntroHeader className={cn(styles['root__introheader'])}>
            <ContentLayout.Main.IntroHeader.Content>
              <div className={cn(styles['title-with-button'])}>
                <h1>{page.title}</h1>

                {page.introButtonAcf?.button && (
                  <Button
                    href={page.introButtonAcf?.button.url}
                    outline
                    {...(page.introButtonAcf?.button.target && { target: page.introButtonAcf?.button.target })}
                  >
                    {page.introButtonAcf?.button.title}
                  </Button>
                )}
              </div>
            </ContentLayout.Main.IntroHeader.Content>
          </ContentLayout.Main.IntroHeader>

          <DynamicContent data={acfMain} />
        </ContentLayout.Main>

        {showSidebar && acfAside.length > 0 ? (
          <ContentLayout.Aside className={cn(styles['root__aside'])}>
            <DynamicContent data={acfAside} />
          </ContentLayout.Aside>
        ) : null}
      </ContentLayout>

      <BecomeMember data={page.webinarsAcf.becomeMember} />
    </AppLayout>
  )
}

export async function getStaticProps() {
  try {
    const { data } = await WebinarService().index({ id: 'webinars' })
    const { data: layoutData } = await LayoutService().index()
    let page = data.page
    if (!page) return { notFound: true }

    const socialsData = data.theme.settings.socials || {}
    const socials = Object.entries(socialsData).map(([key, value]) => ({ name: key, url: value }))

    page.sections = getSectionData(data.page.sections)
    page.socials = socials

    return {
      props: { page, layoutData },
    }
  } catch (error) {
    throw new Error(error)
  }
}

export default Page
